import React, { useState } from 'react';
import Login from '../../components/login/Login';
import { useTranslation } from 'react-i18next';
import RequestPasswordChange from '../../components/requestPasswordChange/RequestPasswordChange';

export function LoginPage({ loginUser }) {
  // state to control forgotten password component or login component
  const [forgottenPass, setForgottenPass] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <div className='content'>
        <div className='App text-center'>
          <h1>{t(!forgottenPass ? 'pages.loginPage.welcomeMessage' : 'pages.loginPage.forgottenPassword.title')}</h1>
          {!forgottenPass ? (
            <Login
              loginUser={loginUser}
              forgottenPassword={() => setForgottenPass(true)}
            />
          ) : (
            <RequestPasswordChange goToLogin={() => setForgottenPass(false)} />
          )}
        </div>
      </div>
    </>
  );
}

export default LoginPage;
